import { motion } from "framer-motion";
import BOOK from "../images/p.png";
import BOOK1 from "../images/knk.jpg";

const BookShop = () => {
  const contentBlocks = [
    {
      title: "Preserving Gospel Literature",
      image: BOOK1,
      imageAlt: "BCS Bookshop publication archive",
      overlayImage: BOOK,
      overlayAlt: "Bookshop collection placeholder",
      paragraphs: [
        "The BCS Bookshop was established in the early 1970s to distribute the Everlasting Gospels of the Supernatural Teacher, Great Leader Olumba Olumba Obu.",
        "From its earliest years, the Bookshop has served as a trusted channel for preserving and circulating key spiritual publications within the Brotherhood.",
      ],
    },
    {
      title: "Sustaining Publication Continuity",
      image: BOOK1,
      imageAlt: "Publication workflow placeholder",
      overlayImage: BOOK,
      overlayAlt: "Print production placeholder",
      paragraphs: [
        "Early gospel materials were typed on stencils and reproduced on low-cost paper so they could reach members and communities at an affordable price.",
        "The Bookshop also supported the production and circulation of Pentecostal Assembly minutes, council proceedings, and doctrinal materials relevant to the BCS fold.",
      ],
    },
    {
      title: "Supporting Faith Scholarship",
      image: BOOK1,
      imageAlt: "Faith research resources placeholder",
      overlayImage: BOOK,
      overlayAlt: "Library access placeholder",
      paragraphs: [
        "Dedicated workers documented and compiled spoken teachings into durable print resources for long-term preservation and wider distribution.",
        "These publications have enabled researchers, students, and readers to study Brotherhood doctrine, sacraments, leadership principles, and related religious scholarship with greater clarity.",
      ],
    },
  ];

  return (
    <motion.main
      initial={{ opacity: 0, scale: 0.98 }}
      animate={{ opacity: 1, scale: 1 }}
      transition={{
        duration: 1.1,
        delay: 0.2,
        ease: [0, 0.71, 0.2, 1.01],
      }}
      className="relative z-0 w-full bg-white text-slate-900"
    >
      <header className="relative z-0 pt-24 mt-24 md:pt-32 px-6 md:px-20 overflow-hidden">
        <div className="absolute inset-0 overflow-hidden pointer-events-none">
          <div className="absolute -top-40 left-1/2 -translate-x-1/2 w-[20px] h-[20px] rounded-full bg-blue-200/40 blur-[10px]" />
          <div className="absolute bottom-0 left-1/4 w-[10px] h-[10px] rounded-full bg-blue-100/50 blur-[10px]" />
          <div className="absolute bottom-0 right-1/4 w-[10px] h-[10px] rounded-full bg-indigo-100/50 blur-[10px]" />
        </div>

        <div className="relative max-w-5xl mx-auto flex flex-col items-center text-center gap-8">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.7 }}
            className="inline-flex items-center gap-4"
          ></motion.div>

          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8, delay: 0.1 }}
            className="space-y-4"
          >
            <h1 className="text-5xl md:text-7xl font-black text-stone-900 tracking-tighter leading-none uppercase">
              BCS <span className="text-blue-600 italic">Bookshop.</span>
            </h1>
            <p className="text-stone-500 text-base md:text-xl font-medium leading-relaxed max-w-3xl mx-auto">
              Preserving sacred publications, expanding access to doctrine,
              <br /> and strengthening spiritual learning across generations.
            </p>
          </motion.div>
        </div>
      </header>

      <section className="px-6 md:px-20 py-16 md:py-28 space-y-28">
        {contentBlocks.map((block, index) => {
          const isOdd = index % 2 !== 0;
          const overlayAlignmentClass = isOdd ? "-left-10" : "-right-10";

          return (
            <article
              key={block.title}
              className="grid md:grid-cols-2 gap-14 md:gap-24 items-center"
            >
              <div className={isOdd ? "md:order-2" : ""}>
                <div className="relative">
                  <img
                    src={block.image}
                    alt={block.imageAlt}
                    className="w-full h-[300px] md:h-[420px] object-cover border border-slate-300"
                  />
                  <img
                    src={block.overlayImage}
                    alt={block.overlayAlt}
                    className={`hidden md:block absolute -bottom-10 ${overlayAlignmentClass} w-[46%] h-[180px] object-cover border-4 border-white shadow-xl`}
                  />
                </div>
              </div>

              <div className={`${isOdd ? "md:order-1" : ""} md:px-6 lg:px-10`}>
                <h2 className="text-2xl md:text-4xl leading-tight font-semibold text-slate-900">
                  {block.title}
                </h2>
                <div className="mt-6 space-y-4 text-base md:text-lg leading-relaxed text-slate-700">
                  {block.paragraphs.map((paragraph) => (
                    <p key={paragraph}>{paragraph}</p>
                  ))}
                </div>
              </div>
            </article>
          );
        })}
      </section>
    </motion.main>
  );
};

export default BookShop;
